import { render, staticRenderFns } from "./CarbonMissingFooter.vue?vue&type=template&id=586b72c8&"
import script from "./CarbonMissingFooter.vue?vue&type=script&lang=ts&"
export * from "./CarbonMissingFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports